<template>
  <div v-if="showBool" class="loading_box" id="__Loading_Id" @touchmove.prevent>
    <div class="loader_inner">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";

let _timer: number | null = null;

const showBool = ref(false);
function show(time = 60000) {
  if (_timer) window.clearTimeout(_timer);
  showBool.value = true;
  _timer = window.setTimeout(() => {
    showBool.value = false;
  }, time);
}
function hide() {
  if (_timer) window.clearTimeout(_timer);
  showBool.value = false;
}

defineExpose({ show, hide });
</script>

<style lang="scss" scoped>
.loading_box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  .loader_inner > div:nth-child(1) {
    -webkit-animation: loader_inner 1s 0.1s infinite
      cubic-bezier(0.2, 0.68, 0.18, 1.08);
    animation: loader_inner 1s 0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  }

  .loader_inner > div:nth-child(2) {
    -webkit-animation: loader_inner 1s 0.2s infinite
      cubic-bezier(0.2, 0.68, 0.18, 1.08);
    animation: loader_inner 1s 0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  }

  .loader_inner > div:nth-child(3) {
    -webkit-animation: loader_inner 1s 0.3s infinite
      cubic-bezier(0.2, 0.68, 0.18, 1.08);
    animation: loader_inner 1s 0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  }

  .loader_inner > div {
    display: inline-block;
    width: 0.1rem;
    height: 0.3rem;
    margin: 0.02rem;
    border-radius: 0.04rem;

    background-color: #ff5500;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  @-webkit-keyframes loader_inner {
    0% {
      -webkit-transform: scaley(1);
      transform: scaley(1);
    }

    50% {
      -webkit-transform: scaley(0.4);
      transform: scaley(0.4);
    }

    100% {
      -webkit-transform: scaley(1);
      transform: scaley(1);
    }
  }

  @keyframes loader_inner {
    0% {
      -webkit-transform: scaley(1);
      transform: scaley(1);
    }

    50% {
      -webkit-transform: scaley(0.4);
      transform: scaley(0.4);
    }

    100% {
      -webkit-transform: scaley(1);
      transform: scaley(1);
    }
  }
}
</style>